var $2c834c34ae0d2db6$exports = {};
$2c834c34ae0d2db6$exports = {
    "placeholder": `Select\u{2026}`,
    "loading": `Loading\u{2026}`
};


export {$2c834c34ae0d2db6$exports as default};
//# sourceMappingURL=en-US.mjs.map
